export default {
  arrives: 'Chegada',
  journeyDuration: 'Duração da viagem',
}
